import React, { useMemo } from "react";
import { useAppVariant, useTranslations } from "@jugl-web/utils";
import { CRMChannel } from "@jugl-web/rest-api";
import { InstagramAccountCard } from "../../components/InstagramAccountCard";
import { WhatsappAccountCard } from "../../components/WhatsappAccountCard";
import { WebChatBotAccountCard } from "../../components/WebChatBotAccountCard/WebChatBotAccountCard";
import { TwilioAccountCard } from "../../components/TwilioAccountCard/TwilioAccountCard";
import { CRMDrawerTabsLayout } from "../../components/CRMDrawerTabsLayout";

const channelComponents = {
  [CRMChannel.instagram]: InstagramAccountCard,
  [CRMChannel.whatsapp]: WhatsappAccountCard,
  [CRMChannel.chatbot]: WebChatBotAccountCard,
  [CRMChannel.twilio]: TwilioAccountCard,
};

export const ConnectedAccountListScreen: React.FC = () => {
  const { t } = useTranslations();
  const allChannels = useMemo(() => Object.values(CRMChannel), []);

  const { isCx } = useAppVariant();

  const content = (
    <div className="flex h-full items-center justify-center p-10">
      <div className="flex w-full max-w-full flex-col gap-4">
        <div className="flex items-end justify-center">
          <div className="flex flex-col justify-center gap-2">
            <span className="font-secondary text-center text-2xl font-medium text-black">
              {t({
                id: "client-support-page.connected-channels",
                defaultMessage: "Connected Channels",
              })}
            </span>
            <span className="font-secondary text-[#828282]">
              {t({
                id: "client-support-page.make-communication-with-customers-easy",
                defaultMessage:
                  "Make the communication with your Customers easy ✨",
              })}
            </span>
          </div>
        </div>
        <div className="jugl__custom-scrollbar overflow-x-auto py-10 px-10">
          <div className="flex w-max min-w-full items-center justify-center gap-6">
            {allChannels.map((channel) => {
              const Component = channelComponents[channel];
              if (!Component) return null;

              return (
                <div key={channel} className="shrink-0">
                  <Component hideReconnectOption isClickable variant="tile" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );

  if (isCx) {
    return content;
  }

  return <CRMDrawerTabsLayout>{content}</CRMDrawerTabsLayout>;
};
